import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {QRCodeCanvas}  from "qrcode.react";
import useMobileAccess from "../../hooks/useMobileAccess";
import {useConfig} from "../../hooks/useConfig";

export default function PublishModalRightPane({uniqueCode}) {
  const isMobile = useMobileAccess();
  const hostname = window.location.hostname;
    const config = useConfig();
  let shortName = '';
        if (hostname.includes(config.host_url)) {
            shortName = hostname.indexOf('.') >= 0 ?
                hostname.substring(hostname.indexOf('.') + 1, hostname.indexOf("engage.yuja.com") - 1) :
                hostname;
        } else {
            shortName = hostname.indexOf('.') >= 0 ?
                hostname.substring(0, hostname.indexOf('.')) :
                hostname;
        }
  const INST_URL = shortName + '.' + config.host_url;
  return (
    <Container>
      <Row>
        <Col>
          <span className="scan-qr-text">Scan QR Code</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <QRCodeCanvas
            bgColor={"#f6f6f6"}
            style={{ margin: "10px" }}
            renderAs="canvas"
            size={isMobile ? 180 : 250}
            value={INST_URL + "/qr/" + uniqueCode}
          />
        </Col>
      </Row>
    </Container>
  );
}
